import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';
import React from 'react';

export const Info = Styled(
	createSvgIcon(
		<svg
			width='14'
			height='15'
			viewBox='0 0 14 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M7.00002 13.7709C3.54085 13.7709 0.729187 10.9592 0.729187 7.50002C0.729187 4.04085 3.54085 1.22919 7.00002 1.22919C10.4592 1.22919 13.2709 4.04085 13.2709 7.50002C13.2709 10.9592 10.4592 13.7709 7.00002 13.7709ZM7.00002 2.10419C4.02502 2.10419 1.60419 4.52502 1.60419 7.50002C1.60419 10.475 4.02502 12.8959 7.00002 12.8959C9.97502 12.8959 12.3959 10.475 12.3959 7.50002C12.3959 4.52502 9.97502 2.10419 7.00002 2.10419Z'
				fill='#919294'
			/>
			<path
				d='M7 8.52085C6.76083 8.52085 6.5625 8.32252 6.5625 8.08335V5.16669C6.5625 4.92752 6.76083 4.72919 7 4.72919C7.23917 4.72919 7.4375 4.92752 7.4375 5.16669V8.08335C7.4375 8.32252 7.23917 8.52085 7 8.52085Z'
				fill='#919294'
			/>
			<path
				d='M7.00002 10.4167C6.92419 10.4167 6.84835 10.3992 6.77835 10.37C6.70835 10.3408 6.64419 10.3 6.58585 10.2475C6.53335 10.1892 6.49252 10.1308 6.46335 10.055C6.43419 9.98501 6.41669 9.90918 6.41669 9.83335C6.41669 9.75751 6.43419 9.68168 6.46335 9.61168C6.49252 9.54168 6.53335 9.47751 6.58585 9.41918C6.64419 9.36668 6.70835 9.32585 6.77835 9.29668C6.91835 9.23835 7.08169 9.23835 7.22169 9.29668C7.29169 9.32585 7.35585 9.36668 7.41419 9.41918C7.46669 9.47751 7.50752 9.54168 7.53669 9.61168C7.56585 9.68168 7.58335 9.75751 7.58335 9.83335C7.58335 9.90918 7.56585 9.98501 7.53669 10.055C7.50752 10.1308 7.46669 10.1892 7.41419 10.2475C7.35585 10.3 7.29169 10.3408 7.22169 10.37C7.15169 10.3992 7.07585 10.4167 7.00002 10.4167Z'
				fill='#919294'
			/>
		</svg>,
		'Info'
	)
);

export default Info;
